/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEcwidCustomer = /* GraphQL */ `
  query GetEcwidCustomer($id: ID!) {
    getEcwidCustomer(id: $id) {
      customerId
      email
      acceptMarketing
      b2b_b2c
      billingPerson
      contacts
      customerGroupId
      customerGroupName
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      favorites
      fiscalCode
      lang
      name
      privateAdminNotes
      registered
      shippingAddresses
      stats
      taxExempt
      taxId
      taxIdValid
      totalOrderCount
      updated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEcwidCustomers = /* GraphQL */ `
  query ListEcwidCustomers(
    $filter: ModelEcwidCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEcwidCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        customerId
        email
        acceptMarketing
        b2b_b2c
        billingPerson
        contacts
        customerGroupId
        customerGroupName
        electronicInvoicePecEmail
        electronicInvoiceSdiCode
        favorites
        fiscalCode
        lang
        name
        privateAdminNotes
        registered
        shippingAddresses
        stats
        taxExempt
        taxId
        taxIdValid
        totalOrderCount
        updated
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEcwidCustomers = /* GraphQL */ `
  query SyncEcwidCustomers(
    $filter: ModelEcwidCustomerFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEcwidCustomers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        customerId
        email
        acceptMarketing
        b2b_b2c
        billingPerson
        contacts
        customerGroupId
        customerGroupName
        electronicInvoicePecEmail
        electronicInvoiceSdiCode
        favorites
        fiscalCode
        lang
        name
        privateAdminNotes
        registered
        shippingAddresses
        stats
        taxExempt
        taxId
        taxIdValid
        totalOrderCount
        updated
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const ecwidCustomersByEmail = /* GraphQL */ `
  query EcwidCustomersByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEcwidCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ecwidCustomersByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        email
        acceptMarketing
        b2b_b2c
        billingPerson
        contacts
        customerGroupId
        customerGroupName
        electronicInvoicePecEmail
        electronicInvoiceSdiCode
        favorites
        fiscalCode
        lang
        name
        privateAdminNotes
        registered
        shippingAddresses
        stats
        taxExempt
        taxId
        taxIdValid
        totalOrderCount
        updated
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEcwidProduct = /* GraphQL */ `
  query GetEcwidProduct($id: ID!) {
    getEcwidProduct(id: $id) {
      productId
      name
      sku
      thumbnailUrl
      unlimited
      inStock
      price
      priceInProductList
      defaultDisplayedPrice
      defaultDisplayedPriceFormatted
      tax
      lowestPrice
      defaultDisplayedLowestPrice
      defaultDisplayedLowestPriceFormatted
      lowestPriceSettings
      isShippingRequired
      hasFreeShipping
      url
      autogeneratedSlug
      customSlug
      created
      updated
      createTimestamp
      updateTimestamp
      productClassId
      enabled
      options
      warningLimit
      fixedShippingRateOnly
      fixedShippingRate
      shipping
      defaultCombinationId
      imageUrl
      smallThumbnailUrl
      hdThumbnailUrl
      originalImageUrl
      originalImage
      borderInfo
      description
      descriptionTranslated
      galleryImages
      media
      categoryIds
      categories
      defaultCategoryId
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      favorites
      attributes
      files
      relatedProducts
      combinations
      dimensions
      shippingPreparationTime
      showDeliveryTimeInStorefront
      volume
      showOnFrontpage
      isSampleProduct
      googleItemCondition
      isGiftCard
      discountsAllowed
      nameYourPriceEnabled
      subscriptionSettings
      googleProductCategory
      googleProductCategoryName
      productCondition
      outOfStockVisibilityBehaviour
      nameTranslated
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEcwidProducts = /* GraphQL */ `
  query ListEcwidProducts(
    $filter: ModelEcwidProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEcwidProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        productId
        name
        sku
        thumbnailUrl
        unlimited
        inStock
        price
        priceInProductList
        defaultDisplayedPrice
        defaultDisplayedPriceFormatted
        tax
        lowestPrice
        defaultDisplayedLowestPrice
        defaultDisplayedLowestPriceFormatted
        lowestPriceSettings
        isShippingRequired
        hasFreeShipping
        url
        autogeneratedSlug
        customSlug
        created
        updated
        createTimestamp
        updateTimestamp
        productClassId
        enabled
        options
        warningLimit
        fixedShippingRateOnly
        fixedShippingRate
        shipping
        defaultCombinationId
        imageUrl
        smallThumbnailUrl
        hdThumbnailUrl
        originalImageUrl
        originalImage
        borderInfo
        description
        descriptionTranslated
        galleryImages
        media
        categoryIds
        categories
        defaultCategoryId
        seoTitle
        seoTitleTranslated
        seoDescription
        seoDescriptionTranslated
        favorites
        attributes
        files
        relatedProducts
        combinations
        dimensions
        shippingPreparationTime
        showDeliveryTimeInStorefront
        volume
        showOnFrontpage
        isSampleProduct
        googleItemCondition
        isGiftCard
        discountsAllowed
        nameYourPriceEnabled
        subscriptionSettings
        googleProductCategory
        googleProductCategoryName
        productCondition
        outOfStockVisibilityBehaviour
        nameTranslated
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEcwidProducts = /* GraphQL */ `
  query SyncEcwidProducts(
    $filter: ModelEcwidProductFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEcwidProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        productId
        name
        sku
        thumbnailUrl
        unlimited
        inStock
        price
        priceInProductList
        defaultDisplayedPrice
        defaultDisplayedPriceFormatted
        tax
        lowestPrice
        defaultDisplayedLowestPrice
        defaultDisplayedLowestPriceFormatted
        lowestPriceSettings
        isShippingRequired
        hasFreeShipping
        url
        autogeneratedSlug
        customSlug
        created
        updated
        createTimestamp
        updateTimestamp
        productClassId
        enabled
        options
        warningLimit
        fixedShippingRateOnly
        fixedShippingRate
        shipping
        defaultCombinationId
        imageUrl
        smallThumbnailUrl
        hdThumbnailUrl
        originalImageUrl
        originalImage
        borderInfo
        description
        descriptionTranslated
        galleryImages
        media
        categoryIds
        categories
        defaultCategoryId
        seoTitle
        seoTitleTranslated
        seoDescription
        seoDescriptionTranslated
        favorites
        attributes
        files
        relatedProducts
        combinations
        dimensions
        shippingPreparationTime
        showDeliveryTimeInStorefront
        volume
        showOnFrontpage
        isSampleProduct
        googleItemCondition
        isGiftCard
        discountsAllowed
        nameYourPriceEnabled
        subscriptionSettings
        googleProductCategory
        googleProductCategoryName
        productCondition
        outOfStockVisibilityBehaviour
        nameTranslated
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEcwidOrder = /* GraphQL */ `
  query GetEcwidOrder($id: ID!) {
    getEcwidOrder(id: $id) {
      orderId
      internalId
      refundedAmount
      subtotal
      subtotalWithoutTax
      total
      totalWithoutTax
      giftCardRedemption
      totalBeforeGiftCardRedemption
      giftCardDoubleSpending
      email
      paymentMethod
      tax
      customerTaxExempt
      customerTaxId
      customerTaxIdValid
      b2b_b2c
      reversedTaxApplied
      customerRequestedInvoice
      customerFiscalCode
      electronicInvoicePecEmail
      electronicInvoiceSdiCode
      ipAddress
      couponDiscount
      paymentStatus
      fulfillmentStatus
      orderNumber
      vendorOrderNumber
      publicUid
      refererUrl
      orderComments
      volumeDiscount
      customerId
      membershipBasedDiscount
      totalAndMembershipBasedDiscount
      customDiscount
      customSurcharges
      discount
      usdTotal
      globalReferer
      createDate
      updateDate
      createTimestamp
      updateTimestamp
      items
      refunds
      billingPerson
      predictedPackage
      shippingLabelAvailableForShipment
      shipments
      additionalInfo
      paymentParams
      extraFields
      ticket
      hidden
      taxesOnShipping
      disableAllCustomerNotifications
      externalFulfillment
      utmDataSets
      invoices
      pricesIncludeTax
      loyalty
      customerUserAgent
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEcwidOrders = /* GraphQL */ `
  query ListEcwidOrders(
    $filter: ModelEcwidOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEcwidOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        orderId
        internalId
        refundedAmount
        subtotal
        subtotalWithoutTax
        total
        totalWithoutTax
        giftCardRedemption
        totalBeforeGiftCardRedemption
        giftCardDoubleSpending
        email
        paymentMethod
        tax
        customerTaxExempt
        customerTaxId
        customerTaxIdValid
        b2b_b2c
        reversedTaxApplied
        customerRequestedInvoice
        customerFiscalCode
        electronicInvoicePecEmail
        electronicInvoiceSdiCode
        ipAddress
        couponDiscount
        paymentStatus
        fulfillmentStatus
        orderNumber
        vendorOrderNumber
        publicUid
        refererUrl
        orderComments
        volumeDiscount
        customerId
        membershipBasedDiscount
        totalAndMembershipBasedDiscount
        customDiscount
        customSurcharges
        discount
        usdTotal
        globalReferer
        createDate
        updateDate
        createTimestamp
        updateTimestamp
        items
        refunds
        billingPerson
        predictedPackage
        shippingLabelAvailableForShipment
        shipments
        additionalInfo
        paymentParams
        extraFields
        ticket
        hidden
        taxesOnShipping
        disableAllCustomerNotifications
        externalFulfillment
        utmDataSets
        invoices
        pricesIncludeTax
        loyalty
        customerUserAgent
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEcwidOrders = /* GraphQL */ `
  query SyncEcwidOrders(
    $filter: ModelEcwidOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEcwidOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        orderId
        internalId
        refundedAmount
        subtotal
        subtotalWithoutTax
        total
        totalWithoutTax
        giftCardRedemption
        totalBeforeGiftCardRedemption
        giftCardDoubleSpending
        email
        paymentMethod
        tax
        customerTaxExempt
        customerTaxId
        customerTaxIdValid
        b2b_b2c
        reversedTaxApplied
        customerRequestedInvoice
        customerFiscalCode
        electronicInvoicePecEmail
        electronicInvoiceSdiCode
        ipAddress
        couponDiscount
        paymentStatus
        fulfillmentStatus
        orderNumber
        vendorOrderNumber
        publicUid
        refererUrl
        orderComments
        volumeDiscount
        customerId
        membershipBasedDiscount
        totalAndMembershipBasedDiscount
        customDiscount
        customSurcharges
        discount
        usdTotal
        globalReferer
        createDate
        updateDate
        createTimestamp
        updateTimestamp
        items
        refunds
        billingPerson
        predictedPackage
        shippingLabelAvailableForShipment
        shipments
        additionalInfo
        paymentParams
        extraFields
        ticket
        hidden
        taxesOnShipping
        disableAllCustomerNotifications
        externalFulfillment
        utmDataSets
        invoices
        pricesIncludeTax
        loyalty
        customerUserAgent
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEcwidCategory = /* GraphQL */ `
  query GetEcwidCategory($id: ID!) {
    getEcwidCategory(id: $id) {
      categoryId
      parentId
      orderBy
      hdThumbnailUrl
      thumbnailUrl
      imageUrl
      originalImageUrl
      originalImage
      thumbnail
      borderInfo
      name
      nameTranslated
      url
      autogeneratedSlug
      customSlug
      productCount
      enabledProductCount
      description
      descriptionTranslated
      enabled
      isSampleCategory
      seoTitle
      seoTitleTranslated
      seoDescription
      seoDescriptionTranslated
      alt
      id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listEcwidCategories = /* GraphQL */ `
  query ListEcwidCategories(
    $filter: ModelEcwidCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEcwidCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        categoryId
        parentId
        orderBy
        hdThumbnailUrl
        thumbnailUrl
        imageUrl
        originalImageUrl
        originalImage
        thumbnail
        borderInfo
        name
        nameTranslated
        url
        autogeneratedSlug
        customSlug
        productCount
        enabledProductCount
        description
        descriptionTranslated
        enabled
        isSampleCategory
        seoTitle
        seoTitleTranslated
        seoDescription
        seoDescriptionTranslated
        alt
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEcwidCategories = /* GraphQL */ `
  query SyncEcwidCategories(
    $filter: ModelEcwidCategoryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEcwidCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        categoryId
        parentId
        orderBy
        hdThumbnailUrl
        thumbnailUrl
        imageUrl
        originalImageUrl
        originalImage
        thumbnail
        borderInfo
        name
        nameTranslated
        url
        autogeneratedSlug
        customSlug
        productCount
        enabledProductCount
        description
        descriptionTranslated
        enabled
        isSampleCategory
        seoTitle
        seoTitleTranslated
        seoDescription
        seoDescriptionTranslated
        alt
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAppConfig = /* GraphQL */ `
  query GetAppConfig($id: ID!) {
    getAppConfig(id: $id) {
      key
      enabled
      message
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listAppConfigs = /* GraphQL */ `
  query ListAppConfigs(
    $filter: ModelAppConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        key
        enabled
        message
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAppConfigs = /* GraphQL */ `
  query SyncAppConfigs(
    $filter: ModelAppConfigFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAppConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        key
        enabled
        message
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const appConfigsByKey = /* GraphQL */ `
  query AppConfigsByKey(
    $key: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appConfigsByKey(
      key: $key
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        key
        enabled
        message
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getRedirect = /* GraphQL */ `
  query GetRedirect($id: ID!) {
    getRedirect(id: $id) {
      id
      oldPath
      newPath
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listRedirects = /* GraphQL */ `
  query ListRedirects(
    $filter: ModelRedirectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRedirects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        oldPath
        newPath
        code
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRedirects = /* GraphQL */ `
  query SyncRedirects(
    $filter: ModelRedirectFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRedirects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        oldPath
        newPath
        code
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const redirectsByOldPath = /* GraphQL */ `
  query RedirectsByOldPath(
    $oldPath: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRedirectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    redirectsByOldPath(
      oldPath: $oldPath
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        oldPath
        newPath
        code
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCoupon = /* GraphQL */ `
  query GetCoupon($id: ID!) {
    getCoupon(id: $id) {
      id
      restrictTo
      startDate
      endDate
      discount
      enabled
      couponCode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCoupons = /* GraphQL */ `
  query ListCoupons(
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoupons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        restrictTo
        startDate
        endDate
        discount
        enabled
        couponCode
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCoupons = /* GraphQL */ `
  query SyncCoupons(
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCoupons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        restrictTo
        startDate
        endDate
        discount
        enabled
        couponCode
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const couponsByCouponCode = /* GraphQL */ `
  query CouponsByCouponCode(
    $couponCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    couponsByCouponCode(
      couponCode: $couponCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        restrictTo
        startDate
        endDate
        discount
        enabled
        couponCode
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSecret = /* GraphQL */ `
  query GetSecret($id: ID!) {
    getSecret(id: $id) {
      id
      type
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSecrets = /* GraphQL */ `
  query ListSecrets(
    $filter: ModelSecretFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSecrets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        value
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSecrets = /* GraphQL */ `
  query SyncSecrets(
    $filter: ModelSecretFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSecrets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        type
        value
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAnnouncement = /* GraphQL */ `
  query GetAnnouncement($id: ID!) {
    getAnnouncement(id: $id) {
      id
      title
      sendTo
      readBy
      message
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listAnnouncements = /* GraphQL */ `
  query ListAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        sendTo
        readBy
        message
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAnnouncements = /* GraphQL */ `
  query SyncAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAnnouncements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        sendTo
        readBy
        message
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCommunication = /* GraphQL */ `
  query GetCommunication($id: ID!) {
    getCommunication(id: $id) {
      id
      subject
      body
      images
      video
      sendTo
      show
      publishDate
      topics
      listItems
      appArea
      countDownTo
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCommunications = /* GraphQL */ `
  query ListCommunications(
    $filter: ModelCommunicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subject
        body
        images
        video
        sendTo
        show
        publishDate
        topics
        listItems
        appArea
        countDownTo
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCommunications = /* GraphQL */ `
  query SyncCommunications(
    $filter: ModelCommunicationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCommunications(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        subject
        body
        images
        video
        sendTo
        show
        publishDate
        topics
        listItems
        appArea
        countDownTo
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const communicationsByAppArea = /* GraphQL */ `
  query CommunicationsByAppArea(
    $appArea: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCommunicationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    communicationsByAppArea(
      appArea: $appArea
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
        body
        images
        video
        sendTo
        show
        publishDate
        topics
        listItems
        appArea
        countDownTo
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getCommunicationTopic = /* GraphQL */ `
  query GetCommunicationTopic($id: ID!) {
    getCommunicationTopic(id: $id) {
      id
      title
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listCommunicationTopics = /* GraphQL */ `
  query ListCommunicationTopics(
    $filter: ModelCommunicationTopicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunicationTopics(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncCommunicationTopics = /* GraphQL */ `
  query SyncCommunicationTopics(
    $filter: ModelCommunicationTopicFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCommunicationTopics(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubscriptionPackage = /* GraphQL */ `
  query GetSubscriptionPackage($id: ID!) {
    getSubscriptionPackage(id: $id) {
      id
      name
      package
      schoolID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubscriptionPackages = /* GraphQL */ `
  query ListSubscriptionPackages(
    $filter: ModelSubscriptionPackageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionPackages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        package
        schoolID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubscriptionPackages = /* GraphQL */ `
  query SyncSubscriptionPackages(
    $filter: ModelSubscriptionPackageFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubscriptionPackages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        package
        schoolID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const subscriptionPackagesBySchool = /* GraphQL */ `
  query SubscriptionPackagesBySchool(
    $schoolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionPackageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionPackagesBySchool(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        package
        schoolID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubscriptionAccess = /* GraphQL */ `
  query GetSubscriptionAccess($id: ID!) {
    getSubscriptionAccess(id: $id) {
      id
      email
      subscriptionPackageID
      subjectIDs
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubscriptionAccesses = /* GraphQL */ `
  query ListSubscriptionAccesses(
    $filter: ModelSubscriptionAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionAccesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        subscriptionPackageID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubscriptionAccesses = /* GraphQL */ `
  query SyncSubscriptionAccesses(
    $filter: ModelSubscriptionAccessFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubscriptionAccesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        email
        subscriptionPackageID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const subscriptionAccessesByEmail = /* GraphQL */ `
  query SubscriptionAccessesByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionAccessesByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        subscriptionPackageID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const subscriptionAccessesBySubscriptionPackage = /* GraphQL */ `
  query SubscriptionAccessesBySubscriptionPackage(
    $subscriptionPackageID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubscriptionAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionAccessesBySubscriptionPackage(
      subscriptionPackageID: $subscriptionPackageID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        subscriptionPackageID
        subjectIDs
        active
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherProductsOrder = /* GraphQL */ `
  query GetTeacherProductsOrder($id: ID!) {
    getTeacherProductsOrder(id: $id) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      notes
      meta
      thankyouTokenHash
      updatedAtMonth
      createdAtMonth
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTeacherProductsOrders = /* GraphQL */ `
  query ListTeacherProductsOrders(
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherProductsOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherProductsOrders = /* GraphQL */ `
  query SyncTeacherProductsOrders(
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherProductsOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProductsOrdersByTeacherprofileID = /* GraphQL */ `
  query TeacherProductsOrdersByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProductsOrdersByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProductsOrdersByOrderStatus = /* GraphQL */ `
  query TeacherProductsOrdersByOrderStatus(
    $orderStatus: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProductsOrdersByOrderStatus(
      orderStatus: $orderStatus
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProductsOrdersByOrderID = /* GraphQL */ `
  query TeacherProductsOrdersByOrderID(
    $orderID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProductsOrdersByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProductsOrdersByUpdatedAtMonth = /* GraphQL */ `
  query TeacherProductsOrdersByUpdatedAtMonth(
    $updatedAtMonth: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProductsOrdersByUpdatedAtMonth(
      updatedAtMonth: $updatedAtMonth
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProductsOrdersByCreatedAtMonth = /* GraphQL */ `
  query TeacherProductsOrdersByCreatedAtMonth(
    $createdAtMonth: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProductsOrdersByCreatedAtMonth(
      createdAtMonth: $createdAtMonth
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        notes
        meta
        thankyouTokenHash
        updatedAtMonth
        createdAtMonth
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getReportingOrderProducts = /* GraphQL */ `
  query GetReportingOrderProducts($id: ID!) {
    getReportingOrderProducts(id: $id) {
      id
      teacherprofileID
      isRecommended
      price
      teacherproductsorderID
      addOnType
      createdAt
      updatedAt
      productID
      productBundleID
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listReportingOrderProducts = /* GraphQL */ `
  query ListReportingOrderProducts(
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportingOrderProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncReportingOrderProducts = /* GraphQL */ `
  query SyncReportingOrderProducts(
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncReportingOrderProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reportingOrderProductsByTeacherprofileID = /* GraphQL */ `
  query ReportingOrderProductsByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportingOrderProductsByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reportingOrderProductsByOrder = /* GraphQL */ `
  query ReportingOrderProductsByOrder(
    $teacherproductsorderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportingOrderProductsByOrder(
      teacherproductsorderID: $teacherproductsorderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reportingOrderProductsByProductID = /* GraphQL */ `
  query ReportingOrderProductsByProductID(
    $productID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportingOrderProductsByProductID(
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reportingOrderProductsByProductBundleID = /* GraphQL */ `
  query ReportingOrderProductsByProductBundleID(
    $productBundleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelReportingOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportingOrderProductsByProductBundleID(
      productBundleID: $productBundleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        isRecommended
        price
        teacherproductsorderID
        addOnType
        createdAt
        updatedAt
        productID
        productBundleID
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getArchivedTeacherProductsOrder = /* GraphQL */ `
  query GetArchivedTeacherProductsOrder($id: ID!) {
    getArchivedTeacherProductsOrder(id: $id) {
      id
      teacherprofileID
      orderShippingDetails
      orderDateTime
      orderStatus
      orderProducts
      orderTotal
      orderVAT
      orderID
      orderPayment
      orderPaymentMethod
      coupon
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listArchivedTeacherProductsOrders = /* GraphQL */ `
  query ListArchivedTeacherProductsOrders(
    $filter: ModelArchivedTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArchivedTeacherProductsOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncArchivedTeacherProductsOrders = /* GraphQL */ `
  query SyncArchivedTeacherProductsOrders(
    $filter: ModelArchivedTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncArchivedTeacherProductsOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const archivedTeacherProductsOrdersByTeacherprofileID = /* GraphQL */ `
  query ArchivedTeacherProductsOrdersByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelArchivedTeacherProductsOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    archivedTeacherProductsOrdersByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        teacherprofileID
        orderShippingDetails
        orderDateTime
        orderStatus
        orderProducts
        orderTotal
        orderVAT
        orderID
        orderPayment
        orderPaymentMethod
        coupon
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($id: ID!) {
    getProductCategory(id: $id) {
      id
      name
      slug
      parentId
      grade
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductCategories = /* GraphQL */ `
  query ListProductCategories(
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        slug
        parentId
        grade
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductCategories = /* GraphQL */ `
  query SyncProductCategories(
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        slug
        parentId
        grade
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProductTag = /* GraphQL */ `
  query GetProductTag($id: ID!) {
    getProductTag(id: $id) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductTags = /* GraphQL */ `
  query ListProductTags(
    $filter: ModelProductTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductTags = /* GraphQL */ `
  query SyncProductTags(
    $filter: ModelProductTagFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductTags(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProductContent = /* GraphQL */ `
  query GetProductContent($id: ID!) {
    getProductContent(id: $id) {
      id
      productId
      fileKeys
      urls
      addons
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductContents = /* GraphQL */ `
  query ListProductContents(
    $filter: ModelProductContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productId
        fileKeys
        urls
        addons
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductContents = /* GraphQL */ `
  query SyncProductContents(
    $filter: ModelProductContentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductContents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productId
        fileKeys
        urls
        addons
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productContentsByProductId = /* GraphQL */ `
  query ProductContentsByProductId(
    $productId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productContentsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        fileKeys
        urls
        addons
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getJustBoughtProduct = /* GraphQL */ `
  query GetJustBoughtProduct($id: ID!) {
    getJustBoughtProduct(id: $id) {
      id
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listJustBoughtProducts = /* GraphQL */ `
  query ListJustBoughtProducts(
    $filter: ModelJustBoughtProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJustBoughtProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        productBundleID
        categoryId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncJustBoughtProducts = /* GraphQL */ `
  query SyncJustBoughtProducts(
    $filter: ModelJustBoughtProductFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncJustBoughtProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        productID
        productBundleID
        categoryId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const justBoughtProductsByProductID = /* GraphQL */ `
  query JustBoughtProductsByProductID(
    $productID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelJustBoughtProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    justBoughtProductsByProductID(
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        productBundleID
        categoryId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const justBoughtProductsByProductBundleID = /* GraphQL */ `
  query JustBoughtProductsByProductBundleID(
    $productBundleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelJustBoughtProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    justBoughtProductsByProductBundleID(
      productBundleID: $productBundleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        productBundleID
        categoryId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const justBoughtProductsByCategoryId = /* GraphQL */ `
  query JustBoughtProductsByCategoryId(
    $categoryId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelJustBoughtProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    justBoughtProductsByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        productBundleID
        categoryId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProductSEO = /* GraphQL */ `
  query GetProductSEO($id: ID!) {
    getProductSEO(id: $id) {
      id
      seoId
      productID
      productBundleID
      Product {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ProductBundle {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductSEOS = /* GraphQL */ `
  query ListProductSEOS(
    $filter: ModelProductSEOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductSEOS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        seoId
        productID
        productBundleID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductSEOS = /* GraphQL */ `
  query SyncProductSEOS(
    $filter: ModelProductSEOFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductSEOS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        seoId
        productID
        productBundleID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productSEOSBySeoId = /* GraphQL */ `
  query ProductSEOSBySeoId(
    $seoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductSEOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productSEOSBySeoId(
      seoId: $seoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seoId
        productID
        productBundleID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productSEOSByProductID = /* GraphQL */ `
  query ProductSEOSByProductID(
    $productID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductSEOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productSEOSByProductID(
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seoId
        productID
        productBundleID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productSEOSByProductBundleID = /* GraphQL */ `
  query ProductSEOSByProductBundleID(
    $productBundleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductSEOFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productSEOSByProductBundleID(
      productBundleID: $productBundleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seoId
        productID
        productBundleID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProductBundle = /* GraphQL */ `
  query GetProductBundle($id: ID!) {
    getProductBundle(id: $id) {
      id
      title
      description
      price
      discountPercentage
      thumbnails
      videoPreview
      products
      tags
      publishDate
      featured
      searchField
      recommendations
      categoryId
      subjectID
      softDeleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductBundles = /* GraphQL */ `
  query ListProductBundles(
    $filter: ModelProductBundleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductBundles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductBundles = /* GraphQL */ `
  query SyncProductBundles(
    $filter: ModelProductBundleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductBundles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productBundlesByCategoryId = /* GraphQL */ `
  query ProductBundlesByCategoryId(
    $categoryId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductBundleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productBundlesByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productBundlesBySubject = /* GraphQL */ `
  query ProductBundlesBySubject(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductBundleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productBundlesBySubject(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        thumbnails
        videoPreview
        products
        tags
        publishDate
        featured
        searchField
        recommendations
        categoryId
        subjectID
        softDeleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      title
      description
      price
      discountPercentage
      eCommerceProduct
      subscriptionProduct
      thumbnails
      videoPreview
      tags
      publishDate
      featured
      physical
      searchField
      categoryId
      subjectID
      questions
      sku
      softDeleted
      addons
      recommendations
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProducts = /* GraphQL */ `
  query SyncProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productsByCategoryId = /* GraphQL */ `
  query ProductsByCategoryId(
    $categoryId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByCategoryId(
      categoryId: $categoryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productsBySubject = /* GraphQL */ `
  query ProductsBySubject(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsBySubject(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const productsByType = /* GraphQL */ `
  query ProductsByType(
    $type: String!
    $publishDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByType(
      type: $type
      publishDate: $publishDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        price
        discountPercentage
        eCommerceProduct
        subscriptionProduct
        thumbnails
        videoPreview
        tags
        publishDate
        featured
        physical
        searchField
        categoryId
        subjectID
        questions
        sku
        softDeleted
        addons
        recommendations
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTaxonomy = /* GraphQL */ `
  query GetTaxonomy($id: ID!) {
    getTaxonomy(id: $id) {
      id
      name
      cognitiveLevels {
        label
        percentage
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTaxonomies = /* GraphQL */ `
  query ListTaxonomies(
    $filter: ModelTaxonomyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaxonomies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTaxonomies = /* GraphQL */ `
  query SyncTaxonomies(
    $filter: ModelTaxonomyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTaxonomies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherAssessmentTemplate = /* GraphQL */ `
  query GetTeacherAssessmentTemplate($id: ID!) {
    getTeacherAssessmentTemplate(id: $id) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      instructions
      taxonomy
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listTeacherAssessmentTemplates = /* GraphQL */ `
  query ListTeacherAssessmentTemplates(
    $filter: ModelTeacherAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomy
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherAssessmentTemplates = /* GraphQL */ `
  query SyncTeacherAssessmentTemplates(
    $filter: ModelTeacherAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomy
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherAssessmentTemplatesBySubjectID = /* GraphQL */ `
  query TeacherAssessmentTemplatesBySubjectID(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherAssessmentTemplatesBySubjectID(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomy
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getAssessmentTemplate = /* GraphQL */ `
  query GetAssessmentTemplate($id: ID!) {
    getAssessmentTemplate(id: $id) {
      id
      title
      headings
      fontFamily
      complexity
      totalMarks
      totalMinutes
      questions
      instructions
      taxonomys
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listAssessmentTemplates = /* GraphQL */ `
  query ListAssessmentTemplates(
    $filter: ModelAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomys
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncAssessmentTemplates = /* GraphQL */ `
  query SyncAssessmentTemplates(
    $filter: ModelAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomys
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const assessmentTemplatesBySchoolID = /* GraphQL */ `
  query AssessmentTemplatesBySchoolID(
    $schoolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assessmentTemplatesBySchoolID(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomys
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const assessmentTemplatesBySubjectID = /* GraphQL */ `
  query AssessmentTemplatesBySubjectID(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAssessmentTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    assessmentTemplatesBySubjectID(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        headings
        fontFamily
        complexity
        totalMarks
        totalMinutes
        questions
        instructions
        taxonomys
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherSubjectTemplate = /* GraphQL */ `
  query GetTeacherSubjectTemplate($id: ID!) {
    getTeacherSubjectTemplate(id: $id) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      schoolID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listTeacherSubjectTemplates = /* GraphQL */ `
  query ListTeacherSubjectTemplates(
    $filter: ModelTeacherSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherSubjectTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherSubjectTemplates = /* GraphQL */ `
  query SyncTeacherSubjectTemplates(
    $filter: ModelTeacherSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherSubjectTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherSubjectTemplatesBySchoolID = /* GraphQL */ `
  query TeacherSubjectTemplatesBySchoolID(
    $schoolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherSubjectTemplatesBySchoolID(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherSubjectTemplatesBySubjectID = /* GraphQL */ `
  query TeacherSubjectTemplatesBySubjectID(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherSubjectTemplatesBySubjectID(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        schoolID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubjectTemplate = /* GraphQL */ `
  query GetSubjectTemplate($id: ID!) {
    getSubjectTemplate(id: $id) {
      id
      name
      headings
      fontFamily
      complexity
      totalPoints
      minutes
      template
      subjectID
      schoolID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubjectTemplates = /* GraphQL */ `
  query ListSubjectTemplates(
    $filter: ModelSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        subjectID
        schoolID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubjectTemplates = /* GraphQL */ `
  query SyncSubjectTemplates(
    $filter: ModelSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubjectTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        subjectID
        schoolID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const subjectTemplatesBySubjectID = /* GraphQL */ `
  query SubjectTemplatesBySubjectID(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subjectTemplatesBySubjectID(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        subjectID
        schoolID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const subjectTemplatesBySchoolID = /* GraphQL */ `
  query SubjectTemplatesBySchoolID(
    $schoolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubjectTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subjectTemplatesBySchoolID(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        headings
        fontFamily
        complexity
        totalPoints
        minutes
        template
        subjectID
        schoolID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSchool = /* GraphQL */ `
  query GetSchool($id: ID!) {
    getSchool(id: $id) {
      id
      name
      provinces
      isGeneric
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      schoolImgKey
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSchools = /* GraphQL */ `
  query ListSchools(
    $filter: ModelSchoolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSchools = /* GraphQL */ `
  query SyncSchools(
    $filter: ModelSchoolFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSchools(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherActivity = /* GraphQL */ `
  query GetTeacherActivity($id: ID!) {
    getTeacherActivity(id: $id) {
      id
      label
      type
      endDateTime
      color
      teacherprofileID
      teachersubjecttemplateID
      teacherassessmenttemplateID
      startDateTime
      repeatID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listTeacherActivities = /* GraphQL */ `
  query ListTeacherActivities(
    $filter: ModelTeacherActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        type
        endDateTime
        color
        teacherprofileID
        teachersubjecttemplateID
        teacherassessmenttemplateID
        startDateTime
        repeatID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherActivities = /* GraphQL */ `
  query SyncTeacherActivities(
    $filter: ModelTeacherActivityFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        label
        type
        endDateTime
        color
        teacherprofileID
        teachersubjecttemplateID
        teacherassessmenttemplateID
        startDateTime
        repeatID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherActivitiesByTeacherprofileID = /* GraphQL */ `
  query TeacherActivitiesByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherActivitiesByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        type
        endDateTime
        color
        teacherprofileID
        teachersubjecttemplateID
        teacherassessmenttemplateID
        startDateTime
        repeatID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherActivitiesByTeachersubjecttemplateID = /* GraphQL */ `
  query TeacherActivitiesByTeachersubjecttemplateID(
    $teachersubjecttemplateID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherActivitiesByTeachersubjecttemplateID(
      teachersubjecttemplateID: $teachersubjecttemplateID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        type
        endDateTime
        color
        teacherprofileID
        teachersubjecttemplateID
        teacherassessmenttemplateID
        startDateTime
        repeatID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherActivitiesByTeacherassessmenttemplateID = /* GraphQL */ `
  query TeacherActivitiesByTeacherassessmenttemplateID(
    $teacherassessmenttemplateID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherActivitiesByTeacherassessmenttemplateID(
      teacherassessmenttemplateID: $teacherassessmenttemplateID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        type
        endDateTime
        color
        teacherprofileID
        teachersubjecttemplateID
        teacherassessmenttemplateID
        startDateTime
        repeatID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTerm = /* GraphQL */ `
  query GetTerm($id: ID!) {
    getTerm(id: $id) {
      id
      label
      start
      end
      biweeks {
        label
        start
        end
        color
        __typename
      }
      provinces
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listTerms = /* GraphQL */ `
  query ListTerms(
    $filter: ModelTermFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTerms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        label
        start
        end
        provinces
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTerms = /* GraphQL */ `
  query SyncTerms(
    $filter: ModelTermFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTerms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        label
        start
        end
        provinces
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getHoliday = /* GraphQL */ `
  query GetHoliday($id: ID!) {
    getHoliday(id: $id) {
      id
      label
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listHolidays = /* GraphQL */ `
  query ListHolidays(
    $filter: ModelHolidayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHolidays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        label
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncHolidays = /* GraphQL */ `
  query SyncHolidays(
    $filter: ModelHolidayFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncHolidays(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        label
        date
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherClassSubject = /* GraphQL */ `
  query GetTeacherClassSubject($id: ID!) {
    getTeacherClassSubject(id: $id) {
      id
      name
      teacherprofileID
      subjectID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listTeacherClassSubjects = /* GraphQL */ `
  query ListTeacherClassSubjects(
    $filter: ModelTeacherClassSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherClassSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        teacherprofileID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherClassSubjects = /* GraphQL */ `
  query SyncTeacherClassSubjects(
    $filter: ModelTeacherClassSubjectFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherClassSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        teacherprofileID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherClassSubjectsByTeacherprofileID = /* GraphQL */ `
  query TeacherClassSubjectsByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherClassSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherClassSubjectsByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        teacherprofileID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherClassSubjectsBySubjectID = /* GraphQL */ `
  query TeacherClassSubjectsBySubjectID(
    $subjectID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherClassSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherClassSubjectsBySubjectID(
      subjectID: $subjectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        teacherprofileID
        subjectID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSubject = /* GraphQL */ `
  query GetSubject($id: ID!) {
    getSubject(id: $id) {
      id
      grade
      subject
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      SubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherSubjectTemplates {
        nextToken
        startedAt
        __typename
      }
      AssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      TeacherAssessmentTemplates {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listSubjects = /* GraphQL */ `
  query ListSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        grade
        subject
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSubjects = /* GraphQL */ `
  query SyncSubjects(
    $filter: ModelSubjectFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSubjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        grade
        subject
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherSchedule = /* GraphQL */ `
  query GetTeacherSchedule($id: ID!) {
    getTeacherSchedule(id: $id) {
      id
      day
      periods
      periodDuration
      breakDurations
      startTime
      endTime
      teacherprofileID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listTeacherSchedules = /* GraphQL */ `
  query ListTeacherSchedules(
    $filter: ModelTeacherScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        periods
        periodDuration
        breakDurations
        startTime
        endTime
        teacherprofileID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherSchedules = /* GraphQL */ `
  query SyncTeacherSchedules(
    $filter: ModelTeacherScheduleFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        day
        periods
        periodDuration
        breakDurations
        startTime
        endTime
        teacherprofileID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherSchedulesByTeacherprofileID = /* GraphQL */ `
  query TeacherSchedulesByTeacherprofileID(
    $teacherprofileID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherSchedulesByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        periods
        periodDuration
        breakDurations
        startTime
        endTime
        teacherprofileID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getReportingTeacher = /* GraphQL */ `
  query GetReportingTeacher($id: ID!) {
    getReportingTeacher(id: $id) {
      id
      title
      name
      surname
      language
      province
      email
      phone
      registrationDate
      tags
      roles
      productCount
      teacherprofileID
      teacherProfileSchoolId
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listReportingTeachers = /* GraphQL */ `
  query ListReportingTeachers(
    $filter: ModelReportingTeacherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportingTeachers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        email
        phone
        registrationDate
        tags
        roles
        productCount
        teacherprofileID
        teacherProfileSchoolId
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncReportingTeachers = /* GraphQL */ `
  query SyncReportingTeachers(
    $filter: ModelReportingTeacherFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncReportingTeachers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        email
        phone
        registrationDate
        tags
        roles
        productCount
        teacherprofileID
        teacherProfileSchoolId
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const reportingTeachersByTeacherprofileID = /* GraphQL */ `
  query ReportingTeachersByTeacherprofileID(
    $teacherprofileID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelReportingTeacherFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportingTeachersByTeacherprofileID(
      teacherprofileID: $teacherprofileID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        email
        phone
        registrationDate
        tags
        roles
        productCount
        teacherprofileID
        teacherProfileSchoolId
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getTeacherProfile = /* GraphQL */ `
  query GetTeacherProfile($id: ID!) {
    getTeacherProfile(id: $id) {
      id
      title
      name
      surname
      language
      province
      daysPerWeek
      status
      TeacherSchedules {
        nextToken
        startedAt
        __typename
      }
      TeacherClassSubjects {
        nextToken
        startedAt
        __typename
      }
      TeacherActivities {
        nextToken
        startedAt
        __typename
      }
      TeacherProductsOrders {
        nextToken
        startedAt
        __typename
      }
      School {
        id
        name
        provinces
        isGeneric
        schoolImgKey
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      payfastSubscriptionToken
      sessionToken
      productsOrderShippingDetails
      products
      payfastSubscriptionResponse
      productSubscriptions
      communicationTopics
      payfastSubscriptionPackage
      translateI18n
      smartProductSort
      type
      createdAt
      updatedAt
      owner
      _version
      _deleted
      _lastChangedAt
      teacherProfileSchoolId
      __typename
    }
  }
`;
export const listTeacherProfiles = /* GraphQL */ `
  query ListTeacherProfiles(
    $filter: ModelTeacherProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeacherProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        name
        surname
        language
        province
        daysPerWeek
        status
        payfastSubscriptionToken
        sessionToken
        productsOrderShippingDetails
        products
        payfastSubscriptionResponse
        productSubscriptions
        communicationTopics
        payfastSubscriptionPackage
        translateI18n
        smartProductSort
        type
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        teacherProfileSchoolId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncTeacherProfiles = /* GraphQL */ `
  query SyncTeacherProfiles(
    $filter: ModelTeacherProfileFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncTeacherProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        daysPerWeek
        status
        payfastSubscriptionToken
        sessionToken
        productsOrderShippingDetails
        products
        payfastSubscriptionResponse
        productSubscriptions
        communicationTopics
        payfastSubscriptionPackage
        translateI18n
        smartProductSort
        type
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        teacherProfileSchoolId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProfilesByUpdatedAt = /* GraphQL */ `
  query TeacherProfilesByUpdatedAt(
    $type: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProfilesByUpdatedAt(
      type: $type
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        daysPerWeek
        status
        payfastSubscriptionToken
        sessionToken
        productsOrderShippingDetails
        products
        payfastSubscriptionResponse
        productSubscriptions
        communicationTopics
        payfastSubscriptionPackage
        translateI18n
        smartProductSort
        type
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        teacherProfileSchoolId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const teacherProfilesByOwner = /* GraphQL */ `
  query TeacherProfilesByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTeacherProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    teacherProfilesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        name
        surname
        language
        province
        daysPerWeek
        status
        payfastSubscriptionToken
        sessionToken
        productsOrderShippingDetails
        products
        payfastSubscriptionResponse
        productSubscriptions
        communicationTopics
        payfastSubscriptionPackage
        translateI18n
        smartProductSort
        type
        createdAt
        updatedAt
        owner
        _version
        _deleted
        _lastChangedAt
        teacherProfileSchoolId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
